import { render, staticRenderFns } from "./globalDialog.vue?vue&type=template&id=0f015cfb"
import script from "./globalDialog.vue?vue&type=script&lang=js"
export * from "./globalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports